<template>
  <tr :class="{'font-weight-bold bg-dark text-white': data.highlighted}">
    <td data-label=" ">
      <strong>
        {{ data.title }}
      </strong>
    </td>
    <td data-label="Total">
       {{ data.total | toDollarAmount }}
    </td>
    <td data-label="Count">
        {{ data.count }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'WokrOrderSummaryRow',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      data () {
        return {
          ...this.object
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/WorkOrderSummary.vue